import {FC} from 'react';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const headCells = [
  {
    disablePadding: false,
    id: 'id',
    label: '№',
    align: 'left' as const,
  },
  {
    disablePadding: false,
    id: 'date',
    label: 'Дата недопуска',
    align: 'left' as const,
    scope: 'row',
  },
  {
    disablePadding: false,
    id: 'edit',
    label: '',
    width: 84,
    align: 'left' as const,
  },
  {
    disablePadding: false,
    id: 'photo',
    label: 'Фото недопуска',
    width: 120,
    align: 'left' as const,
  },
];

export const TableHeadContainer: FC = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="none" width={40} />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            scope={headCell.scope}
            align={headCell.align || 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            width={headCell.width}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
